import Highcharts from "../highcharts.config";

/**
 * Default Highcharts options for the optional number chart sparkline.
 */
export const numberChartSparklineDefaults: Highcharts.Options = {
  chart: {
    type: "line",
    animation: true,
    backgroundColor: "transparent",
    spacing: [0, 0, 0, 0],
    margin: [0, 0, 0, 0],
    height: 60,
  },
  title: { text: undefined },
  subtitle: { text: undefined },
  credits: { enabled: false },
  legend: { enabled: false },
  tooltip: { enabled: false },
  xAxis: {
    visible: false,
    labels: { enabled: false },
    lineWidth: 0,
    tickLength: 0,
  },
  yAxis: {
    visible: false,
    title: { text: undefined },
    labels: { enabled: false },
    gridLineWidth: 0,
  },
  plotOptions: {
    series: {
      animation: false,
      marker: { enabled: false },
      states: {
        hover: { enabled: false },
        inactive: { opacity: 1 },
      },
      lineWidth: 2,
      enableMouseTracking: false,
    },
  },
  series: [],
};
